/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../utils/Theme";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled.button`
  cursor: pointer;
  display: flex;
  background: ${props => (props.inlineStyle ? "white" : Theme.PrimaryColor)};
  color: ${props => (props.inlineStyle ? Theme.PrimaryColor : "white")};
  border: ${props =>
    props.inlineStyle
      ? "1px solid " + Theme.PrimaryColor
      : "0px solid transparent"};
  padding: 0px;
  width: 1.8em;
  height: 1.8em;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  box-shadow: ${props => (props.inlineStyle ? "unset" : "0 4px 6px -5px grey")};
`;

const StyledValue = styled.span`
  text-align: center;
  min-width: 1.1em;
  padding: 0px 10px;
  color: black;
`;

class Stepper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 0,
      decreaseBtn: true,
      increaseBtn: false,
      leftBtnFade: false,
      rightBtnFade: false
    };
  }

  componentDidMount() {
    const { minStep, maxStep, value } = this.props;
    const { currentStep } = this.state;

    if (value) {
      this.setState({
        currentStep: value
      });
    }

    if (currentStep <= minStep) {
      this.setState({
        decreaseBtn: true
      });
    }

    if (currentStep >= maxStep) {
      this.setState({
        increaseBtn: true
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.value !== nextProps.value ||
      this.state.currentStep !== nextProps.value
    ) {
      this.setState({
        currentStep: nextProps.value
      });
    }
  }

  decreaseStep = () => {
    let currentValue = this.state.currentStep;
    let increaseBtn, decreaseBtn;
    const { minStep, maxStep, onChange } = this.props;

    currentValue = currentValue - 1;
    if (currentValue < minStep) {
      currentValue = minStep;
    }

    decreaseBtn = currentValue === minStep;
    increaseBtn = currentValue === maxStep;

    this.setState({
      currentStep: currentValue,
      increaseBtn: increaseBtn,
      decreaseBtn: decreaseBtn,
      leftBtnFade: true
    });

    if (onChange) {
      onChange(currentValue);
    }
  };

  increaseStep = () => {
    let currentValue = this.state.currentStep;
    let increaseBtn, decreaseBtn;
    const { minStep, maxStep, onChange } = this.props;

    currentValue = currentValue + 1;
    if (currentValue > maxStep) {
      currentValue = maxStep;
    }

    decreaseBtn = currentValue === minStep;
    increaseBtn = currentValue === maxStep;

    this.setState({
      currentStep: currentValue,
      increaseBtn: increaseBtn,
      decreaseBtn: decreaseBtn,
      rightBtnFade: true
    });

    if (onChange) {
      onChange(currentValue);
    }
  };

  render() {
    const { decreaseBtn, increaseBtn, leftBtnFade, rightBtnFade } = this.state;
    const { inlineStyle } = this.props;

    return (
      <StyledContainer>
        <StyledButton
          inlineStyle={inlineStyle}
          disabled={decreaseBtn}
          className={leftBtnFade ? "fade" : ""}
          onAnimationEnd={() => this.setState({ leftBtnFade: false })}
          onClick={e => {
            e.stopPropagation();
            this.decreaseStep();
          }}
        >
          -
        </StyledButton>
        <StyledValue>{this.state.currentStep}</StyledValue>
        <StyledButton
          inlineStyle={inlineStyle}
          disabled={increaseBtn}
          className={rightBtnFade ? "fade" : ""}
          onAnimationEnd={() => this.setState({ rightBtnFade: false })}
          onClick={e => {
            e.stopPropagation();
            this.increaseStep();
          }}
        >
          +
        </StyledButton>
      </StyledContainer>
    );
  }
}

Stepper.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  minStep: PropTypes.number,
  maxStep: PropTypes.number,
  inlineStyle: PropTypes.bool
};

Stepper.defaultProps = {
  minStep: 0,
  maxStep: 20,
  inlineStyle: false
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/components/Stepper.js